<template>
    <div class="directors-logo-section">
        <div class="container">
            <div class="default">
                <div class="row">
                    <div class="col-md-12 col-lg-6">
                        <div class="title">Realização</div>

                        <div class="row">
                            <div class="col-md-3 col-6">
                                <img :src="require('@/assets/potencia.png')" alt="logo" data-aos="zoom-in" />
                            </div>

                            <div class="col-md-3 col-6">
                                <img :src="require('@/assets/abh.png')" alt="fundacao_ABH" data-aos="zoom-in" />
                            </div>

                            <div class="col-md-3 col-6">
                                <img :src="require('@/assets/jatobas.png')" alt="fundacao_jatobas" data-aos="zoom-in" />
                            </div>

                            <div class="col-md-3 col-6">
                                <img :src="require('@/assets/setubal.png')" alt="fundacao_setubal" data-aos="zoom-in" />
                            </div>
                            <div class="col-md-1 col-6"></div>
                        </div>
                    </div>

                    <div class="col-md-12 col-lg-6">
                        <div class="row">
                            <div class="col-md-3 col-6">
                                <div class="title">Financiamento</div>

                                <img :src="require('@/assets/bis.png')" alt="fundo_bis1" data-aos="zoom-in" />
                            </div>

                            <div class="col-md-2 col-6"></div>

                            <div class="col-md-3 col-12">
                                <div class="title">Apoio</div>

                                <img :src="require('@/assets/l9.png')" alt="l9" data-aos="zoom-in" />
                            </div>

                            <div class="col-md-3 col-12">
                                <div class="title">Desenvolvimento</div>

                                <img :src="require('@/assets/kiria.png')" alt="logo-kiria" data-aos="zoom-in" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="row">
                   <h3 class="col-12 title">Realizadores</h3>
               </div>

               <div class="row logos">
                   <div class="col-6 col-sm-4 col-md-4">
                       <img :src="require('@/assets/fundacao_ABH.png')" alt="fundacao_ABH" data-aos="zoom-in" />
                   </div>

                   <div class="col-6 col-sm-4 col-md-4">
                       <img
                           :src="require('@/assets/fundacao_jatobas.png')"
                           alt="fundacao_jatobas"
                           data-aos="zoom-in"
                       />
                   </div>

                   <div class="col-6 col-sm-4 col-md-4">
                       <img
                           :src="require('@/assets/fundacao_setubal.png')"
                           alt="fundacao_setubal"
                           data-aos="zoom-in"
                       />
                   </div>

                   <div class="col-6 col-sm-4 col-md-4">
                       <img :src="require('@/assets/ponte_ponte.png')" alt="ponte_ponte" data-aos="zoom-in" />
                   </div>

                   <div class="col-6 col-sm-4 col-md-4">
                       <img :src="require('@/assets/l9.png')" alt="l9" data-aos="zoom-in" />
                   </div>

                   <div class="col-6 col-sm-4 col-md-4">
                       <img :src="require('@/assets/potencia.png')" alt="potencia" data-aos="zoom-in" />
                   </div>
               </div> -->
            </div>

            <div class="gold" v-if="false">
                <div class="row">
                    <h3 class="col-12 title">Patrocinadores ouro</h3>
                </div>

                <div class="row logos">
                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-spotify.svg')" alt="logo-spotify" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-google.svg')" alt="logo-google" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-facebook.svg')" alt="logo-facebook" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-instagram.svg')" alt="logo-instagram" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-microsoft.svg')" alt="logo-microsoft" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-dropbox.svg')" alt="logo-dropbox" />
                    </div>
                </div>
            </div>

            <div class="silver" v-if="false">
                <div class="row">
                    <h3 class="col-12 title">Patrocinadores prata</h3>
                </div>

                <div class="row logos">
                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-spotify.svg')" alt="logo-spotify" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-google.svg')" alt="logo-google" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-facebook.svg')" alt="logo-facebook" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-instagram.svg')" alt="logo-instagram" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-microsoft.svg')" alt="logo-microsoft" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-dropbox.svg')" alt="logo-dropbox" />
                    </div>
                </div>
            </div>

            <div class="bronze" v-if="false">
                <div class="row">
                    <h3 class="col-12 title">Patrocinadores bronze</h3>
                </div>

                <div class="row logos">
                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-spotify.svg')" alt="logo-spotify" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-google.svg')" alt="logo-google" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-facebook.svg')" alt="logo-facebook" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-instagram.svg')" alt="logo-instagram" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-microsoft.svg')" alt="logo-microsoft" />
                    </div>

                    <div class="col-6 col-sm-4 col-md-2">
                        <img :src="require('@/assets/logo-dropbox.svg')" alt="logo-dropbox" />
                    </div>
                </div>
            </div>

            <div class="partners-supporters">
                <div class="row">
                    <div class="col-12 col-md-6" v-if="false">
                        <div class="row">
                            <h3 class="col-12 title">Parceiros</h3>
                        </div>

                        <div class="logos">
                            <div class="row">
                                <div class="col-12 col-sm-4 col-md-4">
                                    <img :src="require('@/assets/logo-spotify.svg')" alt="logo-spotify" />
                                </div>

                                <div class="col-12 col-sm-4 col-md-4">
                                    <img :src="require('@/assets/logo-google.svg')" alt="logo-google" />
                                </div>

                                <div class="col-12 col-sm-4 col-md-4">
                                    <img :src="require('@/assets/logo-facebook.svg')" alt="logo-facebook" />
                                </div>

                                <div class="col-12 col-sm-4 col-md-4">
                                    <img :src="require('@/assets/logo-instagram.svg')" alt="logo-instagram" />
                                </div>

                                <div class="col-12 col-sm-4 col-md-4">
                                    <img :src="require('@/assets/logo-microsoft.svg')" alt="logo-microsoft" />
                                </div>

                                <div class="col-12 col-sm-4 col-md-4">
                                    <img :src="require('@/assets/logo-dropbox.svg')" alt="logo-dropbox" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-12 col-md-12">
                        <div class="row">
                            <h3 class="col-12 title">Apoiadores</h3>
                        </div>

                        <div class="logos">
                            <div class="row">
                                <div class="col"></div>

                                <div class="col-4 col-sm-4 col-md-2">
                                    <img
                                        :src="require('@/assets/fundo_bis1.png')"
                                        alt="fundo_bis1"
                                        data-aos="zoom-in"
                                    />
                                </div>

                                <div class="col"></div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DirectorsLogoSection'
}
</script>

<style scope src="./DirectorsLogoSection-light-theme.css"></style>
<style scope src="./DirectorsLogoSection-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/components/landing-page/directors-logo-section/DirectorsLogoSection.vue